import { Cookiebar } from '@shared/Frontend/apps/web/cookiebar/cookiebar'
import { NetworkStatus } from '@shared/Frontend/apps/web/networkStatus/networkStatus'
import { NotFoundPage } from '@shared/Frontend/utils/notFoundPage'
import { reactContainer } from '@shared/Frontend/utils/reactContainer'
import { unit } from 'ballerina-core'
import i18next from 'i18next'
import React, { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { MonadsTest } from './EntryPoint/Frontend/apps/web/monadsTest/monadsTest'
import { HomePage } from './EntryPoint/Frontend/apps/web/root/homePage'
import { Main } from './EntryPoint/Frontend/apps/web/root/main'
import { SiteFooter } from './EntryPoint/Frontend/apps/web/root/siteFooter'
import { SiteHeader } from './EntryPoint/Frontend/apps/web/root/siteHeader'
import { RootState, initialRootState } from './EntryPoint/Frontend/libraries/root/root.state'
import { RootTemplate } from './EntryPoint/Frontend/libraries/root/root.template'

import '@site-styling/spa.scss' // PROJECT STYLING

export const main = async () => {
  if ((window['run_main' as any] as any) != true) return

  const res = await fetch('/api/v1/translations')
  const resources = await res.json()
  await i18next.init({ resources, lng: document.documentElement.lang })

  if (reactContainer !== null) {
    const root = createRoot(reactContainer)
    root.render(<App />)
  }
}

const App = () => {
  const [rootState, setRootState] = useState(initialRootState())

  useEffect((): void => {
    removeSSR()
  }, [])

  useEffect((): void => {
    state = rootState
  })

  return (
    <RootTemplate
      context={rootState}
      setState={setRootState}
      foreignMutations={unit}
      view={{ Main, SiteHeader, SiteFooter, HomePage, NotFoundPage, ...MonadsTest, Cookiebar, NetworkStatus }}
    />
  )
}

let state: RootState

let releaseCounter = 20

let firstTime = true

const ssrRoot = document.getElementById('rootSSR')

const removeSSR = () =>
  setTimeout(
    () => {
      firstTime = false
      if (hasAsyncLoading(state, undefined) && releaseCounter > 0) {
        releaseCounter--
        removeSSR()
        return
      }

      if (reactContainer) reactContainer.removeAttribute('style')
      if (ssrRoot) {
        ssrRoot.style.display = 'none'
        setTimeout(() => ssrRoot.remove(), 100)
      }
    },
    firstTime ? 1000 : 200
  )

const hasAsyncLoading = (obj: any, parent: any) => {
  if (obj == undefined) return false
  const values = Object.values(obj)

  const traverseKeys = () => {
    for (let value of values) {
      if (value == null || value == undefined) continue
      if (typeof value === 'function') continue
      if (value instanceof Date) continue

      if ((value as any)['kind'] === 'loading') {
        console.warn('found loading', value, obj, parent)
        return true
      }

      if (typeof value === 'string' || value instanceof String) continue
      let hasValueAsyncLoading = hasAsyncLoading(value, obj)
      if (hasValueAsyncLoading) return true
    }
  }

  return traverseKeys()
}

main()
